import axios from "axios";

const rptAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL_RPT,
});

export const setRptAuthToken = (token) => {
  if (token) {
    rptAxios.defaults.headers.common["authorization"] = `Bearer ${token}`;
  } else {
    delete rptAxios.defaults.headers.common["authorization"];
  }
};

export default rptAxios;
